import { setTerm } from './helpers';

export const setUrbanBathroomType = setTerm('wc_type');
